import { ClassificationEstimate } from '@interfaces/ClassificationEstimate';

export class ClassTableRow {
  public classificationCode: string;
  public classificationDescription: string;

  public hours: number;
  public cost: number;
  public billable: number;

  public constructor(classificationEstimate: ClassificationEstimate) {
    this.classificationCode = classificationEstimate.classification?.code;
    this.classificationDescription = classificationEstimate.classification?.description;

    this.hours = 0;
    this.cost = 0;
    this.billable = 0;

    for (const classificationLine of classificationEstimate.classificationLines) {
      this.hours += classificationLine.hours;
      this.cost += classificationLine.hours * classificationLine.rateCost;
      this.billable += classificationLine.hours * classificationLine.rateBillable;
    }
  }
}
